<script setup>
defineOptions({
  inheritAttrs: true,
})
defineProps(['control-id'])
</script>
<template>
  <div class="schema-field-layout">
    <label class="form-label" :for="controlId" v-if="$slots.label">
      <slot name="label" />
    </label>
    <slot name="control" />
  </div>
</template>
